export const Confirmation = () => {
  return (
    <div className='bg-white max-w-[742px] w-full max-h-[370px] h-full mx-auto flex mt-10 flex-col text-center'>
      <div className='checkIcon my-10 mx-auto' />
      <div className='pb-15'>
        <div className='text-[40px] font-semibold'>Thank You!</div>
        <p>Your submission has been received.</p>
      </div>
    </div>
  );
};
